import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, withKeys as _withKeys, createTextVNode as _createTextVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-721f43e0"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "/images/logos/Logo_Tuvast.png",
  width: "140"
}, null, -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Inloggen als huurder", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Gebruikersnaam", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Wachtwoord", -1))

import { authStore } from '@/stores/auth'
import { onBeforeMount, ref } from 'vue'
import { notification } from 'ant-design-vue'
import { useRouter } from 'vue-router'


export default /*#__PURE__*/_defineComponent({
  __name: 'Login',
  setup(__props) {

const auth = authStore()
const router = useRouter()
const username = ref('')
const password = ref('')
const loading = ref(false)

onBeforeMount(() => {
  if (auth.loggedIn) {
    redirectToDashboard()
  }
})

function login () : void {
  loading.value = true
  auth.login(username.value, password.value).then(() => {
    loading.value = false
    redirectToDashboard()
  }).catch((e:{ response: { status:number } }) => {
    if (e.response.status === 401) {
      notification.error({
        message: 'Onjuiste combinatie van gebruikernaam en wachtwoord.',
        description: 'De door u ingevulde combinatie van gebruikersnaam en wachtwoord is onjuist. Probeer het nogmaals.',
        duration: 5
      })
    } else {
      notification.error({
        message: 'Inloggen mislukt.',
        description: 'Er is iets mis gegaan. Probeer het later nogmaals.',
        duration: 5
      })
    }
  }).finally(() => {
    loading.value = false
  })
}

function redirectToDashboard () : void {
  router.push('/dashboard')
}

return (_ctx: any,_cache: any) => {
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_button = _resolveComponent("a-button")!

  return (_openBlock(), _createBlock(_component_a_row, { style: {"height":"100vh"} }, {
    default: _withCtx(() => [
      _createVNode(_component_a_col, {
        xs: 24,
        md: 12,
        xl: 16,
        class: "login-image"
      }),
      _createVNode(_component_a_col, {
        xs: 24,
        md: 12,
        xl: 8,
        style: {"padding":"64px 16px"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_row, { style: {"margin-bottom":"64px"} }, {
            default: _withCtx(() => [
              _createVNode(_component_a_col, {
                span: 20,
                offset: 2
              }, {
                default: _withCtx(() => [
                  _hoisted_1
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_a_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_a_col, {
                span: 20,
                offset: 2
              }, {
                default: _withCtx(() => [
                  _hoisted_2,
                  _createVNode(_component_a_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_col, { span: 24 }, {
                        default: _withCtx(() => [
                          _hoisted_3,
                          _createVNode(_component_a_input, {
                            type: "text",
                            value: username.value,
                            "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((username).value = $event))
                          }, null, 8, ["value"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_col, { span: 24 }, {
                        default: _withCtx(() => [
                          _hoisted_4,
                          _createVNode(_component_a_input, {
                            type: "password",
                            value: password.value,
                            "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((password).value = $event)),
                            onKeyup: _withKeys(login, ["enter"])
                          }, null, 8, ["value", "onKeyup"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_col, { span: 24 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_button, {
                            type: "primary",
                            class: "fw-btn",
                            style: {"margin-bottom":"16px"},
                            loading: loading.value,
                            onClick: login
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Inloggen")
                            ]),
                            _: 1
                          }, 8, ["loading"]),
                          _createVNode(_component_a_button, {
                            type: "link",
                            class: "fw-btn",
                            onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(router).push('/wachtwoord-vergeten')))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Wachtwoord vergeten?")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})